import React from "react";
import { VariantProps } from ".";
import GetPriceByEmail from "./GetPriceByEmail";
import WhyWeDoThis from "./WhyWeDoThis";
import ContactUsForDetails from "./ContactUsForDetails";
import ChatLink from "./ChatLink";
import StandardPrice from "../StandardPrice";
import PlusShippingLevels from "../PlusShippingLevels";
import GoogleViewPrice from "../GoogleViewPrice";
const I = (props: VariantProps) => {
  const {
    itemNumber,
    price,
    showBelowMinimumAdvertisedPriceForLoggedInCustomers,
    hasFreeShipping,
    hasWebPlusDiscountedShipping,
    isWebstaurantPlusEligible,
    isGoogleView,
    unitOfMeasure,
    user,
    minimumBuy,
    mustBuy
  } = props;
  const isInternalUser = user.analyticsData?.is_on_vpn?.toLocaleUpperCase() === "YES";
  return (
    // style names and MAP styles are intentionally mismatched
    <div className="map map-override mapW" data-sentry-component="I" data-sentry-source-file="I.tsx">
      {isGoogleView ? <GoogleViewPrice price={price.price} minimumBuy={minimumBuy} mustBuy={mustBuy} /> : <StandardPrice price={price.price} unitOfMeasure={unitOfMeasure} />}
      <ContactUsForDetails loginOverride={showBelowMinimumAdvertisedPriceForLoggedInCustomers} data-sentry-element="ContactUsForDetails" data-sentry-source-file="I.tsx" />
      <PlusShippingLevels hasFreeShipping={hasFreeShipping} hasWebPlusDiscountedShipping={hasWebPlusDiscountedShipping} isWebstaurantPlusEligible={isWebstaurantPlusEligible} data-sentry-element="PlusShippingLevels" data-sentry-source-file="I.tsx" />
      <p className="to-see-price noborder mb-2">
        <ChatLink data-sentry-element="ChatLink" data-sentry-source-file="I.tsx" />
        <em>
          (Mon-Fri 8AM-8PM EST
          <br />
          Sat &amp; Sun: 9am - 4pm EST)
        </em>
      </p>
      <p className="to-see-price" />
      {!price.hideWhyDoWeDoThis && <WhyWeDoThis type="contact" />}
      {isInternalUser && <GetPriceByEmail email={user.emailAddress} itemNumber={itemNumber} />}
    </div>
  );
};
export default I;